import React from 'react';
import ReactDOM from "react-dom";
import Recaptcha from "react-recaptcha";


import { Formik, Field, Form, FieldArray, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import styled from '@emotion/styled';
import "./main.css";


const StyledErrorMessage = styled.div`
  font-size: 12px;
  color: #e53e3e;
  width: 400px;
  margin-top: 0.25rem;
  &:before {
    content: "Error: ";
  }
  @media (prefers-color-scheme: dark) {
    color: #feb2b2;
  }
`;
 

const initialValues = { 
  companyName: '',
  upsAccount: '',
  name: '',
  addressLine1: '',
  addressLine2: '',
  city: '',
  state: '',
  zip: '',
  orders: [{
    category: '',
    product: '',
    qty: ''
  }]
};


const UPSSupplies = () => {

  const script = document.createElement("script");
    script.src = "https://www.google.com/recaptcha/api.js";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

  return (
  <div className="container-fluid">
      <Formik initialValues={initialValues}

      validationSchema = {Yup.object({
        companyName: Yup.string()
            .max(50, 'Must be 50 characters or less')
            .required('Required'),
        email: Yup.string().email('Must be a valid email address').required('Required'),
        upsAccount: Yup.string()
            .max(6, 'Must be 6 characters').min(6, 'Must be 6 characters')
            .required('Required'), 
        name: Yup.string()
            .max(50, 'Must be 50 characters or less')
            .required('Required'), 
        addressLine1: Yup.string()
            .max(50, 'Must be 50 characters or less')
            .required('Required'), 
        city: Yup.string()
            .max(50, 'Must be 50 characters or less')
            .required('Required'), 
        state: Yup.string()
            .required('Required'), 
        zip: Yup.string()
            .max(6, 'Must be 6 characters or less').min(5, 'Must be at least 5 characters')
            .required('Required'),
        recaptcha: Yup.string().required(),

        orders: Yup.array()
          .of(
            Yup.object().shape({
              qty: Yup.number().required('Required').moreThan(0, 'Must be greater than 0'),
              category: Yup.string().required('Required'),
              product: Yup.string().required('Required'),

            })
          )
        
      })}

      onSubmit =  {(values, { setSubmitting }) => {
        setTimeout(() => {
            var xhr = new XMLHttpRequest();

            xhr.open('POST', 'https://dyhbtrh55c.execute-api.us-west-2.amazonaws.com/dev/ups-supplies-proc', true);
            xhr.setRequestHeader('Accept', 'application/json; charset=utf-8');
            xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhr.responseType = 'json';
            
            xhr.addEventListener('load', function(event) {
                window.location.href = '/static/html/success.html';
            })

            xhr.addEventListener('error', function(event) {
                window.location.href = '/static/html/error.html';
            })

            // Send the collected data as JSON
            xhr.send(JSON.stringify(values));
            

        setSubmitting(false);
        }, 400);
      }}>
        
        {({ values , errors, touched,  isSubmitting, setFieldValue }) => (
        <Form>
          <div className="table-hover">
          <div className="row">
              
              <div className="col-sm-2"></div>
              <div className="col-sm-4">
                <label>Company Name</label>
                <Field name="companyName" type="text" />
                {touched.companyName && errors.companyName ? (<StyledErrorMessage>{errors.companyName}</StyledErrorMessage>) : null}
              </div>
              <div className="col-sm-4">
                <label>UPS Account Number</label>
                <Field name="upsAccount" type="text" placeholder="XXXXXX"/>
                {touched.upsAccount && errors.upsAccount ? (<StyledErrorMessage>{errors.upsAccount}</StyledErrorMessage>) : null}
              </div>
              <div className="col-sm-2"></div>
          </div>

          <div className="row">
            <div className="col-sm-2"></div>
            <div className="col-sm-8">
              <label>Full Name</label>
              <Field name="name" type="text" />
                {touched.name && errors.name ? (<StyledErrorMessage>{errors.name}</StyledErrorMessage>) : null}
              
              <label>Email Address</label>
              <Field name="email" type="text" placeholder="email@company.com" />
              {touched.email && errors.email ? (<StyledErrorMessage>{errors.email}</StyledErrorMessage>) : null}
              
              


              <label>Address (line 1)</label>
              <Field name="addressLine1" type="text" />
                {touched.addressLine1 && errors.addressLine1 ? (<StyledErrorMessage>{errors.addressLine1}</StyledErrorMessage>) : null}
              
              <label>Address (line 2)</label>
              <Field name="addressLine2" type="text" />
                {touched.addressLine2 && errors.addressLine2 ? (<StyledErrorMessage>{errors.addressLine2}</StyledErrorMessage>) : null}
                
            </div>
            <div className="col-sm-2"></div>
          </div>

          <div className="row">
            <div className="col-sm-2"></div>
            <div className="col-sm-5">
              <label>City</label>
              <Field name="city" type="text" />
                {touched.city && errors.city ? (<StyledErrorMessage>{errors.city}</StyledErrorMessage>) : null}
            </div>
            <div className="col-sm-1">
              <label>State</label>
              <Field name="state" as="select">
                <option value="">--</option>
                <option value="AL">AL</option>
                <option value="AK">AK</option>
                <option value="AR">AR</option>	
                <option value="AZ">AZ</option>
                <option value="CA">CA</option>
                <option value="CO">CO</option>
                <option value="CT">CT</option>
                <option value="DC">DC</option>
                <option value="DE">DE</option>
                <option value="FL">FL</option>
                <option value="GA">GA</option>
                <option value="HI">HI</option>
                <option value="IA">IA</option>	
                <option value="ID">ID</option>
                <option value="IL">IL</option>
                <option value="IN">IN</option>
                <option value="KS">KS</option>
                <option value="KY">KY</option>
                <option value="LA">LA</option>
                <option value="MA">MA</option>
                <option value="MD">MD</option>
                <option value="ME">ME</option>
                <option value="MI">MI</option>
                <option value="MN">MN</option>
                <option value="MO">MO</option>	
                <option value="MS">MS</option>
                <option value="MT">MT</option>
                <option value="NC">NC</option>	
                <option value="NE">NE</option>
                <option value="NH">NH</option>
                <option value="NJ">NJ</option>
                <option value="NM">NM</option>			
                <option value="NV">NV</option>
                <option value="NY">NY</option>
                <option value="ND">ND</option>
                <option value="OH">OH</option>
                <option value="OK">OK</option>
                <option value="OR">OR</option>
                <option value="PA">PA</option>
                <option value="RI">RI</option>
                <option value="SC">SC</option>
                <option value="SD">SD</option>
                <option value="TN">TN</option>
                <option value="TX">TX</option>
                <option value="UT">UT</option>
                <option value="VT">VT</option>
                <option value="VA">VA</option>
                <option value="WA">WA</option>
                <option value="WI">WI</option>	
                <option value="WV">WV</option>
                <option value="WY">WY</option>
              </Field>
                {touched.state && errors.state ? (<StyledErrorMessage>{errors.state}</StyledErrorMessage>) : null}
            </div>
            <div className="col-sm-2">
              <label>Zip</label>
              <Field name="zip" type="text" />
                {touched.zip && errors.zip ? (<StyledErrorMessage>{errors.zip}</StyledErrorMessage>) : null}
                
            </div>
            <div className="col-sm-2"></div>
          </div>
          

          <div className="row">
            <div className="col-sm-12">
              <br/>
              <h3>Items to order</h3>
              <p className="text-left">Select the category of item, the name and how many units of the item you need. To add more items, click on the "<b>Add Item</b>" button on the right. If you need to remove
                an item from your inventory, you can choose "<b>Remove</b>". To browse the available items to receive, please select the proper category at the bottom of the page to see
                each item's specific details. When you have finished adding items, please select "<b>Submit Order</b>" to send your items for processing.
              </p>
            </div>
          </div>

          <FieldArray name="orders">
            {({ insert, remove, push }) => (
              <div>
                <div className="row">
                    <div className="col-sm-2"><label>Category</label></div>
                    <div className="col-sm-4"><label>Product</label></div>
                    <div className="col-sm-2"><label>Qty/Unit</label></div>
                    <div className="col-sm-2"><label>Units needed</label></div>
                    <div className="col-sm-2"><label></label></div>
                  </div>
                {values.orders.length > 0 && values.orders.map((order, index) => (
                  
                  <div className="row" key={index}>
                    <div className="col-sm-2">
                      <Field
                        name={`orders.${index}.category`}
                        as="select"
                      >
                        <option value="">Please Select...</option>
                        <option value="envelopes">Envelopes</option>
                        <option value="labels">Labels and Stickers</option>
                        <option value="packaging">Packaging</option>
                        <option value="pouches">Pouches</option>
                      </Field>
                      <ErrorMessage
                          name={`orders.${index}.category`}
                          component="div"
                          className="dropdown-error"
                      />
                    </div>
                    <div className="col-sm-4">
                      
                      {values.orders[index].category === "envelopes" && (
                       <Field
                        name={`orders.${index}.product`}
                        as="select"
                        className="productDrop"
                        >
                        <option value="">Please select...</option>
                        <option value="010195101">010195101 - UPS Express Envelope</option>
                        <option value="010195103">010195103 - UPS Window Envelope</option>
                        <option value="0101951033">0101951033 - UPS Window Envelope - Legal</option>
                        <option value="010195112">010195112 - UPS Express Reusable Envelope</option>
                        <option value="010196122">010196122 - UPS Medical Envelope</option>

                      </Field>
                      )}

                      {values.orders[index].category === "labels" && (
                       <Field
                        name={`orders.${index}.product`}
                        as="select"
                        className="productDrop"
                        >
                        <option value="">Please select...</option>
                        <option value="02774006">02774006 - Direct Thermal Label - Fan-Fold (4 x 6)</option>
                        <option value="02774008">02774008 - Direct Thermal Label - Fan-Fold (4 x 8)</option>
                        <option value="0177400801">0177400801 - Direct Thermal Perforated Label (4 x 8.25) (250/Roll)</option>
                        <option value="01774006">01774006 - UPS Thermal Label (4 x 6)</option>
                        <option value="01774008">01774008 - UPS Thermal Label (4 x 8)</option>
                        <option value="0177400603">0177400603 - Direct Thermal Label - Roll</option>
                        <option value="011127">011127 - Dry Ice for Medical Purposes Sticker</option>
                        <option value="0177400820">0177400820 - UPS Tire Label</option>
                        <option value="01146802">01146802 - Over 70 lbs. Highlight Sticker</option>
                        <option value="01118901">01118901 - Saturday Delivery Sticker</option>
                        <option value="01774501">01774501 - UPS WorldShip Peel-and-Stick Labels - (2 per Sheet)</option>
                        <option value="01774504">01774504 - UPS WorldShip Peel-and-Stick Labels - (4 per Sheet)</option>
                      </Field>

                      )}

                    {(values.orders[index].product === "01774501") && (
                      <p className="dropdown-error">Supplies can only ship to address under the account number.</p>
                    )}

                    {(values.orders[index].product === "0177400801") && (
                      <p className="dropdown-error">Supplies only available for accounts on Worldship and on a Daily Pickup.</p>
                    )}

                      
                      {values.orders[index].category === "packaging" && (
                       <Field
                        name={`orders.${index}.product`}
                        as="select"
                        className="productDrop"
                        >
                        <option value="">Please select...</option>
                        <option value="010195218">010195218 - Security Box Small</option>
                        <option value="010195217">010195217 - Security Box Medium</option>
                        <option value="010195109">010195109 - UPS Express Hard Pak - Secure</option>
                        <option value="010195106">010195106 - UPS Express Boxes (Large)</option>
                        <option value="01019510605">01019510605 - UPS Express Boxes (Med)</option>
                        <option value="01019510603">01019510603 - UPS Express Boxes (Small)</option>
                        <option value="010195106002">010195106002 - UPS Mini Express Box</option>
                        <option value="010195104">010195104 - UPS Pad Pak</option>
                        <option value="010195107">010195107 - UPS Express Tube</option>
                        <option value="010195111">010195111 - UPS Express Pak</option>
                        <option value="01019521501">01019521501 - UPS Laboratory Pak for Biological Substance, Category B</option>
                        <option value="01019521401">01019521401 - UPS Laboratory Pak for Exempt Human or Animal Specimens</option>
                        <option value="010196120">010196120 - UPS Laboratory Box for Exempt Human or Animal Specimens (Small)</option>
                        <option value="010196140">010196140 - UPS Laboratory Box for Exempt Human or Animal Specimens (Medium)</option>
                        <option value="010196150">010196150 - UPS Laboratory Box for Exempt Human or Animal Specimens (Large)</option>
                        <option value="010196141"> 010196141 - UPS Laboratory Box for Biological Substance, Category B (Medium)</option>
                        <option value="010196151">010196151 - UPS Laboratory Box for Biological Substance, Category B (Large)</option>

                      </Field>
                      )}

                      {values.orders[index].category === "pouches" && (
                       <Field
                        name={`orders.${index}.product`}
                        as="select"
                        className="productDrop"
                        >
                          <option value="">Please select...</option>
                        	<option value="01875614">01875614 - International Waybill Pouch</option>
                        	<option value="171604">171604 - Address Pouch</option>
                      </Field>
                      
                      )}

  
                      <ErrorMessage
                          name={`orders.${index}.product`}
                          component="div"
                          className="dropdown-error"
                      />
                    </div>
                    

                    
                    {(values.orders[index].product === "") && (
                      <div className="col-sm-2"> </div>
                    )}

                    {(values.orders[index].product === "0101951033" 
                     || values.orders[index].product === "010195103" 
                     || values.orders[index].product === "010195112"
                     || values.orders[index].product === "010195104"
                     || values.orders[index].product === "010195101"
                     || values.orders[index].product === "01875614") && (
                      <div className="col-sm-2"><input type="text" name={`orders.${index}.units`} defaultValue="25 pieces" readOnly="readonly" /></div>
                    )}
         

                    {(values.orders[index].product === "02774006" 
                     || values.orders[index].product === "02774008" 
                     || values.orders[index].product === "010195218"
                     || values.orders[index].product === "010195217"
                     || values.orders[index].product === "010196122") && (
                      <div className="col-sm-2"><input type="text" name={`orders.${index}.units`} defaultValue="1 case" readOnly="readonly" /></div>
                    )}

                    {(values.orders[index].product === "01774008" 
                     || values.orders[index].product === "01774006"
                     || values.orders[index].product === "0177400603"
                     || values.orders[index].product === "0177400801"
                     || values.orders[index].product === "0177400820"
                     || values.orders[index].product === "01146802"
                     || values.orders[index].product === "01118901") && (
                      <div className="col-sm-2"><input type="text" name={`orders.${index}.units`} defaultValue="1 roll" readOnly="readonly" /></div>
                    )}


                    {(values.orders[index].product === "010195106" 
                     || values.orders[index].product === "01019510605" 
                     || values.orders[index].product === "01019510603"
                     || values.orders[index].product === "010196120"
                     || values.orders[index].product === "010196140"
                     || values.orders[index].product === "010196150"
                     || values.orders[index].product === "010196151"
                     || values.orders[index].product === "010195106002"
                     || values.orders[index].product === "010196141"
                     || values.orders[index].product === "010195106002") && (
                      <div className="col-sm-2"><input type="text" name={`orders.${index}.units`} defaultValue="20 pieces" readOnly="readonly" /></div>
                    )}

                    {(values.orders[index].product === "171604"
                    ||values.orders[index].product === "010195111") && (
                      <div className="col-sm-2"><input type="text" name={`orders.${index}.units`} defaultValue="50 pieces" readOnly="readonly" /></div>
                    )}

                    {(values.orders[index].product === "01774501" 
                     || values.orders[index].product === "01774504") && (
                      <div className="col-sm-2"><input type="text" name={`orders.${index}.units`} defaultValue="50 sheets" readOnly="readonly" /></div>
                    )}


                    {(values.orders[index].product === "010195107") && (
                      <div className="col-sm-2"><input type="text" name={`orders.${index}.units`} defaultValue="5 pieces" readOnly="readonly" /></div>
                    )}

                    {(values.orders[index].product === "010195109") && (
                      <div className="col-sm-2"><input type="text" name={`orders.${index}.units`} defaultValue="10 pieces" readOnly="readonly" /></div>
                    )}

                    {(values.orders[index].product === "011127"
                    || values.orders[index].product === "01019521501"
                    || values.orders[index].product === "01019521401") && (
                      <div className="col-sm-2"><input type="text" name={`orders.${index}.units`} defaultValue="1 pack" readOnly="readonly" /></div>
                    )}

                    
                    
                    <div className="col-sm-2">
                      <Field
                        name={`orders.${index}.qty`}
                        type="text"
                        className="qtyText"
                        
                      />
                      <ErrorMessage
                          name={`orders.${index}.qty`}
                          component="div"
                          className="dropdown-error"
                      />
                    </div>

                    
                    
                    
                    
                    <div className="col-sm-2">

                        <button
                          type="button"
                          className="secondary" 
                          onClick={() => remove(index)}
                        >
                          Remove
                        </button>
                      </div>


                    </div> 

                    


                ))}



                <div className="row">
                  <div className="col-sm-10"></div>
                    <div className="col-sm-2">
                      <button
                        type="button"
                        className="secondary"
                        onClick={() => push({ product: "", category: "", qty: "" })}
                      >Add Item
                      </button>
                  </div>
                </div>
          
              </div>
            )}
          

          </FieldArray>
          </div>

          <div className="row">
            <div className="col-sm-4"></div>
            <div className="col-sm-4">
              <br />
          <Recaptcha
                  sitekey="6LenicoZAAAAAPIkAhdRNVjYCocQHNvLNu2INxFl"
                  render="explicit"
                  theme="light"
                  verifyCallback={(response) => { setFieldValue("recaptcha", response); }}
                  onloadCallback={() => { console.log("done loading!"); }}
                />
                {errors.recaptcha && touched.recaptcha ? (
                  <StyledErrorMessage>{errors.recaptcha}</StyledErrorMessage>
                ) : null}
              </div>
            <div className="col-sm-4"></div>
          </div>


          <div className="row">
         
            <div className="col-sm-5"></div>
            <div className="col-sm-2"> 
            
              <button disabled={isSubmitting} type="submit">Submit Order</button>
              <br/><br/>
            </div>
            <div className="col-sm-5"></div>
  
          </div>


          <div className="row">
            
            <div className="col-sm-12">
            <label>Please select from the product list below to see all of the available items:</label>
            <Field name="productCategory" as="select">
                  <option value="">Please Select...</option>
                  <option value="envelopes">Envelopes</option>
                  <option value="labels">Labels and Stickers</option>
                  <option value="packaging">Packaging</option>
                  <option value="pouches">Pouches</option>
            </Field>
            <br/><br/>
            {values.productCategory === "envelopes" && (
              <div>
                <div className="row">
                  <div className="col-sm-12">
                    <h3>Envelopes</h3>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-1"><p className="text-left"><b>Item #</b></p></div>
                  <div className="col-sm-3"><p className="text-left"><b>Name</b></p></div>
                  <div className="col-sm-2"></div>
                  <div className="col-sm-4"><p className="text-left"><b>Description</b></p></div>
                  <div className="col-sm-1"><p className="text-left"><b>Dimensions</b></p></div>
                  <div className="col-sm-1"><p className="text-left"><b>Quantity</b></p></div>
                </div>
                <div className="row">
                  <div className="col-sm-1"><p className="text-left">010195101</p></div>
                  <div className="col-sm-3"><p className="text-left">UPS Express Envelope</p></div>
                  <div className="col-sm-2"><img src="/img/010195101.gif"  width="134" alt="UPS Express Envelope"/></div>
                  <div className="col-sm-4"><p className="text-left">For urgent correspondence and documents. Use for all UPS Next Day Air, UPS 2nd Day Air, and International services.</p></div>
                  <div className="col-sm-1"><p className="text-left">12.5" x 9.5"</p></div>
                  <div className="col-sm-1"><p className="text-left">25 Pieces</p></div>
                </div>

                <div className="row">
                  <div className="col-sm-1"><p className="text-left">010195103</p></div>
                  <div className="col-sm-3"><p className="text-left">UPS Window Envelope</p></div>
                  <div className="col-sm-2"><img src="/img/010195103.gif"  width="134" alt="UPS Window Envelope"/></div>
                  <div className="col-sm-4"><p className="text-left">For urgent correspondence and documents. Can be used with labels from CampusShip & Internet Shipping. Features a plastic sleeve to insert your label.</p></div>
                  <div className="col-sm-1"><p className="text-left">12.5" x 9.5" </p></div>
                  <div className="col-sm-1"><p className="text-left">25 Pieces</p></div>
                </div>
                <div className="row">
                  <div className="col-sm-1"><p className="text-left">0101951033</p></div>
                  <div className="col-sm-3"><p className="text-left">UPS Window Envelope - Legal</p></div>
                  <div className="col-sm-2"><img src="/img/0101951033.gif"  width="134" alt="UPS Window Envelope - Legal"/></div>
                  <div className="col-sm-4"><p className="text-left">Appropriate for legal-sized documents that cannot be folded. Use with labels from UPS Online WorldShip, Internet Shipping or CampusShip. Features a plastic window to insert the label.</p></div>
                  <div className="col-sm-1"><p className="text-left">15" x 9.5" </p></div>
                  <div className="col-sm-1"><p className="text-left">25 pieces</p></div>
                </div>
                <div className="row">
                  <div className="col-sm-1"><p className="text-left">010195112</p></div>
                  <div className="col-sm-3"><p className="text-left">UPS Express Reusable Envelope</p></div>
                  <div className="col-sm-2"><img src="/img/010195112.gif"  width="134" alt="UPS Express Reusable Envelope"/></div>
                  <div className="col-sm-4"><p className="text-left">Use, reuse, then recycle this envelope. Have documents returned without enclosing another envelope. Reduces paper waste when used a second time - either returned to sender or sent to another recipient.  Made from 100% recycled fiber.</p></div>
                  <div className="col-sm-1"><p className="text-left">12.5" x 9.5" </p></div>
                  <div className="col-sm-1"><p className="text-left">25 Pieces</p></div>
                </div>
                <div className="row">
                  <div className="col-sm-1"><p className="text-left">010196122</p></div>
                  <div className="col-sm-3"><p className="text-left">UPS Medical Envelope</p></div>
                  <div className="col-sm-2"><img src="/img/010196122.gif"  width="134" alt="UPS Medical Envelope"/></div>
                  <div className="col-sm-4"><p className="text-left">UPS Medical Envelopes are designed to be highly visible. Items placed in this envelope must be packaged in accordance with Federal regulatory packaging requirements. (250 per case)</p></div>
                  <div className="col-sm-1"><p className="text-left">12.5" x 9.5"</p></div>
                  <div className="col-sm-1"><p className="text-left">1 case</p></div>
                </div>
              </div>

            )}
            
            {values.productCategory === "labels" && (
            <div>
              <div className="row">
                <div className="col-sm-12">
                  <h3>Labels and Stickers</h3>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-1"><p className="text-left"><b>Item Number</b></p></div>
                <div className="col-sm-3"><p className="text-left"><b>Name</b></p></div>
                <div className="col-sm-2"></div>
                <div className="col-sm-4"><p className="text-left"><b>Description</b></p></div>
                <div className="col-sm-1"><p className="text-left"><b>Dimensions</b></p></div>
                <div className="col-sm-1"><p className="text-left"><b>Quantity</b></p></div>
              </div>
              <div className="row">
                <div className="col-sm-1"><p className="text-left">02774006</p></div>
                <div className="col-sm-3"><p className="text-left">Direct Thermal Label - Fan-Fold (4 x 6)</p></div>
                <div className="col-sm-2"><img src="/img/02774006.png"  width="134" alt="Direct Thermal Label - Fan-Fold (4 x 6)"/></div>
                <div className="col-sm-4"><p className="text-left">Blank shipping labels for use with WorldShip, Internet Shipping and CampusShip. Prints barcodes and/or addresses using a thermal printer. </p></div>
                <div className="col-sm-1"><p className="text-left">4" x 6"</p></div>
                <div className="col-sm-1"><p className="text-left">1 case</p></div>
              </div>
              <div className="row">
                <div className="col-sm-1"><p className="text-left">02774008</p></div>
                <div className="col-sm-3"><p className="text-left">Direct Thermal Label - Fan-Fold (4 x 8)</p></div>
                <div className="col-sm-2"><img src="/img/02774008.png"  width="134" alt="Direct Thermal Label - Fan-Fold (4 x 8)"/></div>
                <div className="col-sm-4"><p className="text-left">Blank shipping labels for use with WorldShip, Internet Shipping and CampusShip. Prints barcodes and/or addresses using a thermal printer. </p></div>
                <div className="col-sm-1"><p className="text-left">4" x 8"</p></div>
                <div className="col-sm-1"><p className="text-left">1 case</p></div>
              </div>
              <div className="row">
                <div className="col-sm-1"><p className="text-left">0177400801</p></div>
                <div className="col-sm-3"><p className="text-left">Direct Thermal Perforated Label (4 x 8.25) - 250 Labels/Roll</p></div>
                <div className="col-sm-2"><img src="/img/0177400801.gif"  width="134" alt="Direct Thermal Perforated Label (4 x 8.25)"/></div>
                <div className="col-sm-4"><p className="text-left">Use with UPS WorldShip ribbonless printers. Prints barcodes and/or addresses. 250 labels per roll.</p></div>
                <div className="col-sm-1"><p className="text-left">4" x 8.25"</p></div>
                <div className="col-sm-1"><p className="text-left">1 roll</p></div>
              </div>
              <div className="row">
                <div className="col-sm-1"><p className="text-left">01774008</p></div>
                <div className="col-sm-3"><p className="text-left">UPS Thermal Label (4 x 8)</p></div>
                <div className="col-sm-2"><img src="/img/01774008.gif"  width="134" alt="UPS Thermal Label (4 x 8)"/></div>
                <div className="col-sm-4"><p className="text-left">Blank shipping labels for use with WorldShip, Internet Shipping and CampusShip. Prints barcodes and/or addresses using a thermal printer.</p></div>
                <div className="col-sm-1"><p className="text-left">4" x 8"</p></div>
                <div className="col-sm-1"><p className="text-left">1 roll</p></div>
              </div>
              <div className="row">
                <div className="col-sm-1"><p className="text-left">01774006</p></div>
                <div className="col-sm-3"><p className="text-left">UPS Thermal Label (4 x 6)</p></div>
                <div className="col-sm-2"><img src="/img/01774006.gif"  width="134" alt="UPS Thermal Label (4 x 6)"/></div>
                <div className="col-sm-4"><p className="text-left">Blank WorldShip Labels. 320 per roll. 1.5 inch core. (320 per roll)</p></div>
                <div className="col-sm-1"><p className="text-left">4" x 6.25"</p></div>
                <div className="col-sm-1"><p className="text-left">1 roll</p></div>
              </div>
              <div className="row">
                <div className="col-sm-1"><p className="text-left">0177400603</p></div>
                <div className="col-sm-3"><p className="text-left">Direct Thermal Label - Roll</p></div>
                <div className="col-sm-2"><img src="/img/0177400603.gif"  width="134" alt="Direct Thermal Label - Roll"/></div>
                <div className="col-sm-4"><p className="text-left">Blank shipping labels for use with WorldShip, Internet Shipping and CampusShip. Prints barcodes and/or addresses using a thermal printer. (940 per roll)</p></div>
                <div className="col-sm-1"><p className="text-left">4" x 6"</p></div>
                <div className="col-sm-1"><p className="text-left">1 roll</p></div>
              </div>
              <div className="row">
                <div className="col-sm-1"><p className="text-left">0177400820</p></div>
                <div className="col-sm-3"><p className="text-left">UPS Tire Label</p></div>
                <div className="col-sm-2"><img src="/img/0177400820.gif"  width="134" alt="UPS Tire Label"/></div>
                <div className="col-sm-4"><p className="text-left">UPS direct thermal tire label specially designed with an adhesive for tires. (150 per roll)</p></div>
                <div className="col-sm-1"><p className="text-left"></p></div>
                <div className="col-sm-1"><p className="text-left">1 roll</p></div>
              </div>
              <div className="row">
                <div className="col-sm-1"><p className="text-left">01146802</p></div>
                <div className="col-sm-3"><p className="text-left">Over 70 lbs. Highlight Sticker</p></div>
                <div className="col-sm-2"><img src="/img/01146802.gif"  width="134" alt="Over 70 lbs. Highlight Sticker"/></div>
                <div className="col-sm-4"><p className="text-left">Required for packages weighing 70 pounds or more, this sticker identifies heavy packages for special attention and handling.</p></div>
                <div className="col-sm-1"><p className="text-left"></p></div>
                <div className="col-sm-1"><p className="text-left">1 roll</p></div>
              </div>
              <div className="row">
                <div className="col-sm-1"><p className="text-left">01118901</p></div>
                <div className="col-sm-3"><p className="text-left">Saturday Delivery Sticker</p></div>
                <div className="col-sm-2"><img src="/img/01118901.gif"  width="134" alt="Saturday Delivery Sticker"/></div>
                <div className="col-sm-4"><p className="text-left">If you're using Saturday Delivery for UPS Next Day Air or UPS Worldwide Express services, place this sticker directly below the address label. (5 per sheet)</p></div>
                <div className="col-sm-1"><p className="text-left"></p></div>
                <div className="col-sm-1"><p className="text-left">1 roll</p></div>
              </div>
              <div className="row">
                <div className="col-sm-1"><p className="text-left">011127</p></div>
                <div className="col-sm-3"><p className="text-left">Dry Ice for Medical Purposes Sticker</p></div>
                <div className="col-sm-2"><img src="/img/011127.gif"  width="134" alt="Dry Ice for Medical Purposes Sticker"/></div>
                <div className="col-sm-4"><p className="text-left">If you are preparing a medical shipment on dry ice for US domestic air service, place this sticker near the address label and enter the weight of dry ice in the space provided. (50 per pack)</p></div>
                <div className="col-sm-1"><p className="text-left"></p></div>
                <div className="col-sm-1"><p className="text-left">1 pack</p></div>
              </div>
              <div className="row">
                <div className="col-sm-1"><p className="text-left">01774501</p></div>
                <div className="col-sm-3"><p className="text-left">UPS WorldShip Peel-and-Stick Labels - (2 per Sheet)</p></div>
                <div className="col-sm-2"><img src="/img/01774501.gif"  width="134" alt="UPS WorldShip Peel-and-Stick Labels - (2 per Sheet)"/></div>
                <div className="col-sm-4"><p className="text-left">For UPS WorldShip or UPS Internet Shipping users to print address labels using their own laser printers. </p></div>
                <div className="col-sm-1"><p className="text-left">8.5" x 5.5" </p></div>
                <div className="col-sm-1"><p className="text-left">50 sheets</p></div>
              </div>
              <div className="row">
                <div className="col-sm-1"><p className="text-left">01774504</p></div>
                <div className="col-sm-3"><p className="text-left">UPS WorldShip Peel-and-Stick Labels - (4 per Sheet)</p></div>
                <div className="col-sm-2"><img src="/img/01774504.png"  width="134" alt="UPS WorldShip Peel-and-Stick Labels - (4 per Sheet)"/></div>
                <div className="col-sm-4"><p className="text-left">For UPS WorldShip or UPS Internet Shipping users to print address labels using their own laser printers.</p></div>
                <div className="col-sm-1"><p className="text-left">4.25" x 5.5"</p></div>
                <div className="col-sm-1"><p className="text-left">50 sheets</p></div>
              </div>
            </div>
            )}
            
            {values.productCategory === "packaging" && (
            <div>
              <div className="row">
                <div className="col-sm-12">
                  <h3>Packaging</h3>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-1"><p className="text-left"><b>Item Number</b></p></div>
                <div className="col-sm-3"><p className="text-left"><b>Name</b></p></div>
                <div className="col-sm-2"></div>
                <div className="col-sm-4"><p className="text-left"><b>Description</b></p></div>
                <div className="col-sm-1"><p className="text-left"><b>Dimensions</b></p></div>
                <div className="col-sm-1"><p className="text-left"><b>Quantity</b></p></div>
              </div>
              <div className="row">
                <div className="col-sm-1"><p className="text-left">010195218</p></div>
                <div className="col-sm-3"><p className="text-left">Security Box Small</p></div>
                <div className="col-sm-2"><img src="/img/010195218.gif"  width="134" alt="Security Box Small"/></div>
                <div className="col-sm-4"><p className="text-left">Security Box Small</p></div>
                <div className="col-sm-1"><p className="text-left">9" x 3" x 6"</p></div>
                <div className="col-sm-1"><p className="text-left">1 case</p></div>
              </div>
              <div className="row">
                <div className="col-sm-1"><p className="text-left">010195217</p></div>
                <div className="col-sm-3"><p className="text-left">Security Box Medium</p></div>
                <div className="col-sm-2"><img src="/img/010195217.gif"  width="134" alt="Security Box Medium"/></div>
                <div className="col-sm-4"><p className="text-left">Security Box Medium (250 per case)</p></div>
                <div className="col-sm-1"><p className="text-left">10" x 3" x 12.5"</p></div>
                <div className="col-sm-1"><p className="text-left">1 case</p></div>
              </div>
              <div className="row">
                <div className="col-sm-1"><p className="text-left">010195109</p></div>
                <div className="col-sm-3"><p className="text-left">UPS Express Hard Pak - Secure</p></div>
                <div className="col-sm-2"><img src="/img/010195109.gif"  width="134" alt="UPS Express Hard Pak - Secure"/></div>
                <div className="col-sm-4"><p className="text-left">A Corrugated box with inner liner, designed for shipping electronic media containing sensitive information. Features dual-locking closure for additional security.</p></div>
                <div className="col-sm-1"><p className="text-left">14.75" x 11.5"</p></div>
                <div className="col-sm-1"><p className="text-left">10 pieces</p></div>
              </div>
              <div className="row">
                <div className="col-sm-1"><p className="text-left">010195106</p></div>
                <div className="col-sm-3"><p className="text-left">UPS Express Boxes (Large)</p></div>
                <div className="col-sm-2"><img src="/img/010195106.png"  width="134" alt="UPS Express Boxes (Large)"/></div>
                <div className="col-sm-4"><p className="text-left">Suited for a wide variety of merchandise. Designed for shipments weighing up to 30lbs. Exterior dimensions rounded to the nearest inch. </p></div>
                <div className="col-sm-1"><p className="text-left">18" x 13" x 3" </p></div>
                <div className="col-sm-1"><p className="text-left">20 pieces</p></div>
              </div>
              <div className="row">
                <div className="col-sm-1"><p className="text-left">01019510605</p></div>
                <div className="col-sm-3"><p className="text-left">UPS Express Boxes (Med)</p></div>
                <div className="col-sm-2"><img src="/img/01019510605.png"  width="134" alt="UPS Express Boxes (Med)"/></div>
                <div className="col-sm-4"><p className="text-left">Suited for a wide variety of merchandise, including legal size binders and documents. Exterior dimensions rounded to the nearest inch. (5 per sheet)</p></div>
                <div className="col-sm-1"><p className="text-left">16" x 11" x 3"</p></div>
                <div className="col-sm-1"><p className="text-left">20 pieces</p></div>
              </div>
              <div className="row">
                <div className="col-sm-1"><p className="text-left">01019510603</p></div>
                <div className="col-sm-3"><p className="text-left">UPS Express Boxes (Snall)</p></div>
                <div className="col-sm-2"><img src="/img/01019510603.png"  width="134" alt="UPS Express Boxes (Snall)"/></div>
                <div className="col-sm-4"><p className="text-left">Designed to accommodate smaller items such as books, tapes, etc. Exterior dimensions rounded to the nearest inch. (50 per pack)</p></div>
                <div className="col-sm-1"><p className="text-left">13" x 11" x 2"</p></div>
                <div className="col-sm-1"><p className="text-left">20 pieces</p></div>
              </div>
              <div className="row">
                <div className="col-sm-1"><p className="text-left">010195106002</p></div>
                <div className="col-sm-3"><p className="text-left">UPS Mini Express Box</p></div>
                <div className="col-sm-2"><img src="/img/010195106002.png"  width="134" alt="UPS Mini Express Box"/></div>
                <div className="col-sm-4"><p className="text-left">A corrugated carton designed to hold small items.</p></div>
                <div className="col-sm-1"><p className="text-left">8" x 3" x 6"</p></div>
                <div className="col-sm-1"><p className="text-left">20 pieces</p></div>
              </div>

              <div className="row">
                <div className="col-sm-1"><p className="text-left">010195104</p></div>
                <div className="col-sm-3"><p className="text-left">UPS Pad Pak</p></div>
                <div className="col-sm-2"><img src="/img/010195104.gif"  width="134" alt="UPS Pad Pak"/></div>
                <div className="col-sm-4"><p className="text-left">A Pak lined with bubble wrap; appropriate for flat, unbreakable articles such as computer reports.</p></div>
                <div className="col-sm-1"><p className="text-left">14.75" x 11"</p></div>
                <div className="col-sm-1"><p className="text-left">25 pieces</p></div>
              </div>
              <div className="row">
                <div className="col-sm-1"><p className="text-left">010195107</p></div>
                <div className="col-sm-3"><p className="text-left">UPS Express Tube</p></div>
                <div className="col-sm-2"><img src="/img/010195107.gif"  width="134" alt="UPS Express Tube"/></div>
                <div className="col-sm-4"><p className="text-left">Ideal for documents which must be rolled rather than folded such as blue prints, charts, maps, drawings, and posters. Exterior dimensions rounded to the nearest inch.</p></div>
                <div className="col-sm-1"><p className="text-left">38" x 6" x 6"</p></div>
                <div className="col-sm-1"><p className="text-left">5 pieces</p></div>
              </div>
              <div className="row">
                <div className="col-sm-1"><p className="text-left">010195111</p></div>
                <div className="col-sm-3"><p className="text-left">UPS Express Pak</p></div>
                <div className="col-sm-2"><img src="/img/010195111.gif"  width="134" alt="UPS Express Pak"/></div>
                <div className="col-sm-4"><p className="text-left">Appropriate for flat, unbreakable articles such as computer reports and large reports.</p></div>
                <div className="col-sm-1"><p className="text-left">16" x 12.75"</p></div>
                <div className="col-sm-1"><p className="text-left">50 pieces</p></div>
              </div>

              <div className="row">
                <div className="col-sm-1"><p className="text-left">01019521501</p></div>
                <div className="col-sm-3"><p className="text-left">UPS Laboratory Pak for Biological Substance, Category B</p></div>
                <div className="col-sm-2"><img src="/img/01019521501.gif"  width="134" alt="UPS Laboratory Pak for Biological Substance, Category B"/></div>
                <div className="col-sm-4"><p className="text-left">Ship UN3373 "Biological Substance, Category B" materials in this watertight plastic overwrap. Specimens placed in this Pak must be packaged in accordance with Federal regulatory packaging requirements. This Pak acts as an overwrap only. (50 per Pack)</p></div>
                <div className="col-sm-1"><p className="text-left">17.25" x 12.75" </p></div>
                <div className="col-sm-1"><p className="text-left">1 pack</p></div>
              </div>

              <div className="row">
                <div className="col-sm-1"><p className="text-left">01019521401</p></div>
                <div className="col-sm-3"><p className="text-left">UPS Laboratory Pak for Exempt Human or Animal Specimens</p></div>
                <div className="col-sm-2"><img src="/img/01019521401.gif"  width="134" alt="UPS Laboratory Pak for Exempt Human or Animal Specimens"/></div>
                <div className="col-sm-4"><p className="text-left">Ship routine diagnostic materials that meet the definition of Exempt Human or Exempt Animal specimens in this watertight plastic overwrap. Specimens should be triple-packed before being placed in this Laboratory Pak. (50 per Pack)</p></div>
                <div className="col-sm-1"><p className="text-left">17.25" x 12.75"</p></div>
                <div className="col-sm-1"><p className="text-left">1 pack</p></div>
              </div>

              <div className="row">
                <div className="col-sm-1"><p className="text-left">010196120</p></div>
                <div className="col-sm-3"><p className="text-left">UPS Laboratory Box for Exempt Human or Animal Specimens (Small)</p></div>
                <div className="col-sm-2"><img src="/img/010196120.gif"  width="134" alt="UPS Laboratory Box for Exempt Human or Animal Specimens (Small)"/></div>
                <div className="col-sm-4"><p className="text-left">UPS Lab Boxes are designed to be highly visible and serve as overwraps for Exempt Human and Animal Substances.  Specimens must be packaged in accordance with Federal regulatory packaging requirements.</p></div>
                <div className="col-sm-1"><p className="text-left">13" x 11" x 2" </p></div>
                <div className="col-sm-1"><p className="text-left">20 pieces</p></div>
              </div>

              <div className="row">
                <div className="col-sm-1"><p className="text-left">010196140</p></div>
                <div className="col-sm-3"><p className="text-left">UPS Laboratory Box for Exempt Human or Animal Specimens (Medium)</p></div>
                <div className="col-sm-2"><img src="/img/010196120.gif"  width="134" alt="UPS Laboratory Box for Exempt Human or Animal Specimens (Medium)"/></div>
                <div className="col-sm-4"><p className="text-left">UPS Lab Boxes are designed to be highly visible and serve as overwraps for Exempt Human and Animal Substances.  Specimens must be packaged in accordance with Federal regulatory packaging requirements.</p></div>
                <div className="col-sm-1"><p className="text-left">16" x 11" x 3" </p></div>
                <div className="col-sm-1"><p className="text-left">20 pieces</p></div>
              </div>

              <div className="row">
                <div className="col-sm-1"><p className="text-left">010196150</p></div>
                <div className="col-sm-3"><p className="text-left">UPS Laboratory Box for Exempt Human or Animal Specimens (Large)</p></div>
                <div className="col-sm-2"><img src="/img/010196120.gif"  width="134" alt="UPS Laboratory Box for Exempt Human or Animal Specimens (Large)"/></div>
                <div className="col-sm-4"><p className="text-left">UPS Lab Boxes are designed to be highly visible and serve as overwraps for Exempt Human and Animal Substances.  Specimens must be packaged in accordance with Federal regulatory packaging requirements.</p></div>
                <div className="col-sm-1"><p className="text-left">18" x 11" x 3" </p></div>
                <div className="col-sm-1"><p className="text-left">20 pieces</p></div>
              </div>

              <div className="row">
                <div className="col-sm-1"><p className="text-left">010196141</p></div>
                <div className="col-sm-3"><p className="text-left">UPS Laboratory Box for Biological Substance, Category B (Medium)</p></div>
                <div className="col-sm-2"><img src="/img/010196120.gif"  width="134" alt="UPS Laboratory Box for Biological Substance, Category B (Medium)"/></div>
                <div className="col-sm-4"><p className="text-left">UPS Lab Boxes are designed to be highly visible and serve as overwraps for Biological Substance, Category B substances.  Specimens must be packaged in accordance with Federal regulatory packaging requirements.</p></div>
                <div className="col-sm-1"><p className="text-left">16" x 11" x 3" </p></div>
                <div className="col-sm-1"><p className="text-left">20 pieces</p></div>
              </div>

              <div className="row">
                <div className="col-sm-1"><p className="text-left">010196151</p></div>
                <div className="col-sm-3"><p className="text-left">UPS Laboratory Box for Biological Substance, Category B (Large)</p></div>
                <div className="col-sm-2"><img src="/img/010196120.gif"  width="134" alt="UPS Laboratory Box for Biological Substance, Category B (Large)"/></div>
                <div className="col-sm-4"><p className="text-left">UPS Lab Boxes are designed to be highly visible and serve as overwraps for Biological Substance, Category B substances.  Specimens must be packaged in accordance with Federal regulatory packaging requirements.</p></div>
                <div className="col-sm-1"><p className="text-left">18" x 13" x 3" </p></div>
                <div className="col-sm-1"><p className="text-left">20 pieces</p></div>
              </div>


            </div>
            )}

            {values.productCategory === "pouches" && (
            <div>
              <div className="row">
                <div className="col-sm-12">
                  <h3>Pouches</h3>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-1"><p className="text-left"><b>Item Number</b></p></div>
                <div className="col-sm-3"><p className="text-left"><b>Name</b></p></div>
                <div className="col-sm-2"></div>
                <div className="col-sm-4"><p className="text-left"><b>Description</b></p></div>
                <div className="col-sm-1"><p className="text-left"><b>Dimensions</b></p></div>
                <div className="col-sm-1"><p className="text-left"><b>Quantity</b></p></div>
              </div>
              <div className="row">
                <div className="col-sm-1"><p className="text-left">01875614</p></div>
                <div className="col-sm-3"><p className="text-left">International Waybill Pouch</p></div>
                <div className="col-sm-2"><img src="/img/01875614.gif"  width="134" alt="International Waybill Pouch"/></div>
                <div className="col-sm-4"><p className="text-left">A resealable plastic pouch that holds documentation required for international shipments. Peel-off backing for easy application.</p></div>
                <div className="col-sm-1"><p className="text-left">7.5" x 12"</p></div>
                <div className="col-sm-1"><p className="text-left">25 pieces</p></div>
              </div>
              <div className="row">
                <div className="col-sm-1"><p className="text-left">171604</p></div>
                <div className="col-sm-3"><p className="text-left">Address Pouch</p></div>
                <div className="col-sm-2"><img src="/img/171604.gif"  width="134" alt="Address Pouch"/></div>
                <div className="col-sm-4"><p className="text-left">A see-through protective pouch that adheres to a package for shippers to display plain paper address labels.</p></div>
                <div className="col-sm-1"><p className="text-left">6.5" x 10"</p></div>
                <div className="col-sm-1"><p className="text-left">50 pieces</p></div>
              </div>


            </div>
            )}
            </div>
            
          </div>


         
        
        </Form>

    )}


    </Formik>
    </div>
  )
 }




function App() { 
  return <UPSSupplies />;
}


const rootElement = document.getElementById("root");
ReactDOM.render(<App />, rootElement);
